import { render, staticRenderFns } from "./advanced-wysiwyg.vue?vue&type=template&id=fcf5db96&scoped=true"
import script from "./advanced-wysiwyg.vue?vue&type=script&lang=js"
export * from "./advanced-wysiwyg.vue?vue&type=script&lang=js"
import style0 from "./advanced-wysiwyg.vue?vue&type=style&index=0&id=fcf5db96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf5db96",
  null
  
)

export default component.exports